import type { OpenHouse } from '@bb/domain/dist/types/Listing';
import type { ShowingProvider } from '@bb/common';
import Axios from 'axios';

const getRepsAndOpenHousesForListing = async (
  listingId: string,
  options?: { includeShowingProvider?: boolean },
) => {
  const { data } = await Axios.get<{
    reps: string[];
    openHouses: OpenHouse[];
    showingProvider?: ShowingProvider;
  }>(`/listing/${listingId}/reps_and_open_houses`, {
    params: options?.includeShowingProvider
      ? { includeShowingProvider: 'true' }
      : undefined,
  });
  return data;
};
export default getRepsAndOpenHousesForListing;
